<template>
    <div>
        <div>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <input
                            class="form-control mr-sm-2"
                            type="text"
                            placeholder="เลขที่ใบกำกับภาษีผู้จำหน่าย" v-model="search.tax_number"/>
                        <multiselect
                            v-model="search.vendor"
                            class="form-control border-0"
                            :options="optionVendor"
                            label="name"
                            placeholder="ค้นหาผู้จำหน่าย"
                            :show-labels="false"
                            :customLabel="customVendor"
                            track-by="id">
                        </multiselect>
                        <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            range
                            confirm
                            placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                        </date-picker>
                        &nbsp;
                        <button class="btn btn-success my-2 my-sm-0"
                                type="button" @click="searchTaxPayment(1)">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary"

                                @click="printMultiTaxPayment">
                            <icon name="print"></icon>
                            พิมพ์ใบกำกับภาษี
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-info"
                                :disabled="search.date.length < 1"
                                @click="exportExcel">
                            <icon name="file"></icon>
                            Export Excel
                        </button>
                        &nbsp;
                        <button @click="goToTaxPaymentForm(null)" type="button" class="btn btn-warning">
                            <icon name="plus"></icon>
                            สร้างใบกำกับภาษีซื้อ
                        </button>
                        &nbsp;
                        <button v-if="canViewSuperAdmin"
                                @click.once="showCloseTaxModal"
                                class="btn btn-warning"
                                type="button">
                            <icon name="plus"></icon>
                            ปิดงวดภาษี
                        </button>
                    </form>
                </div>
            </nav>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">
                            #
                        </th>
                        <th>วัน/เดือน/ปี</th>
                        <th>เลขที่ใบกำกับภาษี</th>
                        <th>ชื่อผู้จำหน่าย</th>
                        <th>วันที่ออกใบกำกับภาษีจากผู้จำหน่าย</th>
                        <th>เลขที่ใบกำกับภาษีจากผู้จำหน่าย</th>
                        <th>จำนวนเงิน</th>
                        <th>สถานะปิดงวด</th>
                        <th>พิมพ์</th>
                        <th>ดูข้อมูล</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in tax_payment_list">
                        <td>
                            <input type="checkbox" v-model="checkbox_id"
                                   :value="data"/>
                        </td>
                        <td>
                            <template v-if="data.date">
                                {{ data.date | moment("DD/MM/YYYY") }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_number">
                                {{ data.tax_number }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.vendor">
                                {{ data.vendor.name }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.date_from_vendor">
                                {{ data.date_from_vendor | moment('DD/MM/YYYY') }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax_from_vendor">
                                {{ data.tax_from_vendor }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.total && data.is_vat && data.from_cs">
                                {{ data.total_before_vat | currency }}
                            </template>
                            <template v-else-if="data.total && data.is_vat && !data.from_cs">
                                {{ data.total | currency }}
                            </template>
                            <template v-else-if="data.total">
                                {{ data.total | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            {{ data.closed ? 'ปิดงวด' : '-' }}
                        </td>
                        <td>
                            <button type="button"
                                    :disabled="!data.tax_number"
                                    @click="printTaxPaymentById(data.id)"
                                    class="btn btn-primary">
                                <icon name="print"></icon>
                                พิมพ์
                            </button>
                        </td>
                        <td>
                            <button type="button" class="btn btn-info"
                                    :disabled="data.closed && !canViewSuperAdmin"
                                    @click="goToTaxPaymentForm(data.id)">
                                <icon name="pencil-alt"></icon>
                                ดูข้อมูล
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getPage">
                </vue-pagination>
            </div>
            <b-modal hide-header hide-footer ref="print_tax">
                <print-tax @submit="printTaxPayment">
                </print-tax>
            </b-modal>
            <b-modal hide-footer hide-header ref="close_tax">
                <div style="text-align: center;">
                    <h4>ปิดงวดภาษีซื้อ</h4>
                    <br/>
                    <div class="row form-group">
                        <label class="col-sm-5 text-right">เดือนที่ปิด</label>
                        <div class="col-sm-6">
                            <date-picker v-model="close_date"
                                         :lang="lang"
                                         type="month"
                                         placeholder="เดือนที่ปิด"
                                         class="w-100"
                                         :format="changeFormatMonth"
                                         confirm>
                            </date-picker>
                        </div>
                    </div>

                    <button type="button"
                            class="btn btn-primary"
                            @click="closeTaxMonth"
                    >ยืนยัน
                    </button>
                </div>
            </b-modal>
        </div>
        <!--<pre class="alert-success">{{select_all}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import {domain} from "../../../util/Constants";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import PrintTax from "./PrintTax";
import DatePicker from 'vue2-datepicker'
import ExportExcelModal from "./ExportExcelModal";
import moment from "moment";
import {canViewSuperAdmin} from "@/util/Permissions";

export default {
    components: {
        ExportExcelModal,
        PrintTax,
        VuePagination,
        DatePicker,
        Multiselect,
    },
    name: "tax-payment-list",
    created() {
        this.$store.dispatch("TaxPayment/getTaxPaymentList", {
            page: this.lastPage
        })
        this.$store.dispatch('Vendor/getVendorAll');
    },
    data() {
        return {
            domain: "",
            close_date: '',
            event_submit: false,
            checkbox_id: [],
            select_all: false,
            search: {
                tax_number: "",
                date: [],
                vendor: null,
            },
            page: 1,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            changeFormatMonth: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment);
                    return date ? moment(date).format('MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            tax_payment_list: state => {
                return state.TaxPayment.tax_payment_list
            },
            dataPaginate: state => {
                return state.TaxPayment.dataPaginate
            },
            lastPage: state => {
                return state.TaxPayment.page
            },
            optionVendor: state => {
                return state.Vendor.vendorAll;
            }
        }),
        selectAll: {
            get: function () {
                return this.tax_payment_list ? this.checkbox_id.length >= this.tax_payment_list.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.searchTaxPayment(1);
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            }
        },
        total() {
            // let total = this.tax_payment_list.tax_payment_details.reduce((carry, detail) => {
            //     return carry + detail.total
            // }, 0);
            // if (this.tax_payment_list.is_vat && !this.tax_payment_list.from_cs){
            //     total += this.form.total*0.07
            // }
            // return total
        },
    },
    methods: {
        customVendor(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showCloseTaxModal() {
            this.$refs.close_tax.show();
        },
        hideCloseTaxModal() {
            this.$refs.close_tax.hide();
        },
        closeTaxMonth() {
            if (this.close_date)
                this.$store.dispatch('TaxPayment/closeTaxPayment', moment(this.close_date).format("YYYY-MM")).then(() => {
                    this.hideCloseTaxModal()
                    this.getPage()
                });
            else
                alert('กรุณากรอกเดือนที่ต้องการ')
        },
        goToTaxPaymentForm(id) {
            if (id) {
                this.$store.dispatch("TaxPayment/showTaxPayment", id)
            } else {
                this.$store.dispatch("TaxPayment/clearTaxPayment");
            }
            this.$router.push("/accounting/tax-payment-form");
        },
        printTaxPaymentById(id) {
            let print_id = [];
            print_id.push(id);
            let info = {
                id: print_id
            };
            let data = $.param(info);
            window.open(
                `${domain}/tax-purchase-order-pdf?${data}`,
                '_blank'
            );
        },
        printMultiTaxPayment() {
            if (this.checkbox_id.length > 0) {
                let id = [];
                this.checkbox_id.forEach(data => { //store id
                    id.push(data.id);
                });
                let info = {
                    id: id
                };
                //console.log(info);
                let data = $.param(info);
                window.open(
                    `${domain}/tax-purchase-order-pdf?${data}`,
                    '_blank'
                );
            } else {
                this.showPrintTaxPayment();
            }
        },
        searchTaxPayment(page) {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0) {
                start_date = this.search.date[0] ? moment(this.search.date[0]).format("YYYY-MM-DD") : '';
                end_date = this.search.date[1] ? moment(this.search.date[1]).format("YYYY-MM-DD") : '';
            }
            this.event_submit = true;
            let data = {
                tax_number: this.search.tax_number,
                vendor_id: this.search.vendor ? this.search.vendor.id : '',
                start_date,
                end_date,
            };
            if (this.select_all) {
                this.$store.dispatch("TaxPayment/selectTaxPayment", {
                    page: page,
                    data: data
                }).then(res => {
                    this.checkbox_id = res;
                });
            } else {
                this.$store.dispatch("TaxPayment/searchTaxPayment", {
                    page: page,
                    data: data
                });
            }
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            this.$store.dispatch('TaxPayment/updatePage', this.page)
            if (this.event_submit) {
                this.searchTaxPayment(this.page);
            } else {
                this.$store.dispatch("TaxPayment/getTaxPaymentList", {
                    page: this.page
                })
            }
        },
        showPrintTaxPayment() {
            this.$refs.print_tax.show();
        },
        printTaxPayment(value) {
            if (value) {
                let data = $.param(value);
                window.open(
                    `${domain}/tax-payment-pdf?${data}`,
                    '_blank'
                );
            }
            this.$refs.print_tax.hide();
        },
        exportExcel(value) {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
            } else {
                this.search.date = [];
            }
            if (start_date && end_date) {
                window.open(`${domain}/tax-payment-pdf?range=2&gen=excel&start_date=${start_date}&end_date=${end_date}`);
            }
        }
    }
}
</script>

<style scoped>

</style>
